// import styles
import '@scss/main.scss';
import '@lib/scss/base.lib.scss';
// require main js file
require('@js/index');
require('@js/components/swiper');
require('@js/components/accordion');
require('@js/components/tabs');
require('@js/components/smoth-scrolling');
require('@js/components/mobile-menu');
require('@js/components/img-modal');
//require('@js/components/paypal-button');
require('@js/components/tooltip');
